<script>
import Modal from "@/components/_Shared/Modal";
import { mapActions } from "vuex";

export default {
  components: {
    Modal
  },

  data() {
    return {
      error: "",
      loader: false
    };
  },

  computed: {
    name: {
      get() {
        return this.$store.state.newAddress.name;
      },
      set(value) {
        this.setName(value);
      }
    }
  },

  methods: {
    ...mapActions("newAddress", ["setName", "create"]),
    async confirm() {
      this.loader = true;

      try {
        const valid = await this.$validator.validateAll();
        if (!valid) throw this.errors.items[0].msg;
        const address = await this.create();
        this.$emit("created", address);
      } catch (e) {
        this.error = e;
        this.$toast.error(e);
      }

      this.loader = false;
    },
    optionSelected(event) {
      this.setName(event.srcElement.innerText);
    }
  }
};
</script>

<template>
  <modal
    title="ESCOLHA UM NOME E CADASTRE"
    subtitle="Escolha um nome para o seu endereço e cadastre-o."
    size="md"
  >
    <template slot="body">
      <div class="options">
        <div :class="{ active: name === 'Casa' }" @click="optionSelected">
          Casa
        </div>
        <div
          :class="{ active: name === 'Apartamento' }"
          @click="optionSelected"
        >
          Apartamento
        </div>
        <div :class="{ active: name === 'Trabalho' }" @click="optionSelected">
          Trabalho
        </div>
        <div
          :class="{ active: name === 'Casa dos Pais' }"
          @click="optionSelected"
        >
          Casa dos Pais
        </div>
      </div>

      <input
        type="text"
        class="mt-10"
        v-validate="'required|min:2|max:255'"
        v-model="name"
        name="nome"
        placeholder="escolha uma das opções acima ou digite um nome aqui"
      />

      <div class="error" v-if="error">{{ error }}</div>
    </template>

    <template slot="footer">
      <div class="btn bg-gray" @click="$emit('prev')">voltar</div>
      <div
        class="btn bg-purple"
        :class="{ 'btn--loading': loader }"
        @click="confirm()"
      >
        <span>confirmar e criar</span>
      </div>
    </template>
  </modal>
</template>

<style scoped>
.options {
  display: flex;
  flex-wrap: wrap;
}

.options div {
  padding: 10px;
  border-radius: 5px;
  background-color: #eee;
  font-size: 14px;
  margin: 5px 10px 5px 0;
  cursor: pointer;
  transition: all 0.24s ease;
}

.options div:hover {
  color: var(--pink);
  background-color: var(--pink-light);
}

.options div.active {
  background-color: var(--pink);
  color: #fff;
}

input {
  width: calc(100% - 15px);
  border: 1px solid #ddd;
  flex: 1;
  height: 38px;
  border-radius: 4px;
  padding-left: 10px;
}

.error {
  border-left: 2px solid var(--pink);
  font-size: 14px;
  color: var(--pink);
  margin: 10px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/NewAddress/SetNameAndCreate.vue